import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Thunk to fetch the list with pagination
export const fetchAllSimActivationList = createAsyncThunk(
  "simActivation/fetchAll",
  async (payload, thunkAPI) => {
    try {
      const response = await client.post(
        `${ENDPOINTS.getAllSimActivationList}?pageNo=${payload?.pageNo}&pageSize=${payload?.pageSize}`,
        payload
      );
      return response; // Ensure to return response.data to match the shape of your state
    } catch (error) {
      // Handle the specific error structure
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An unknown error occurred";
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

// Define the initial state
const initialState = {
  simActivationList: [],
  totalRows: 0,
  status: "idle",
  error: null,
};

// Create the slice
const simActivationSlice = createSlice({
  name: "simActivation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllSimActivationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllSimActivationList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.simActivationList = action.payload.data || [];
        state.totalRows = action.payload.totalElements || 0;
        state.error = null; // Clear error on success
      })
      .addCase(fetchAllSimActivationList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default simActivationSlice.reducer;
